import { z } from 'zod';
import { PublicUserSchema } from './user.schema';

export const RaffleStatsSchema = z.object({
   hasWon: z.boolean().nullable(),
   winners: z.array(PublicUserSchema),
});

export const ProductDetailsSchema = z.object({
   category: z.string(),
   details: z.array(
      z.object({
         key: z.string(),
         value: z.string(),
      })
   ),
});

export const ProductItemSchema = z.object({
   id: z.string(),
   sku: z.string(),
   variant: z.string().nullable(),
   type: z.enum(['raffle', 'product']),
   price: z.number(),
   stock: z.number().nullable(),
   levelRequired: z.number().nullable(),
   startsAt: z.string().nullable(),
   endsAt: z.string().nullable(),
   product: z.object({
      id: z.string(),
      name: z.string(),
      description: z.string().nullable(),
      image: z.string(),
      details: z.array(ProductDetailsSchema).nullable().optional(),
      tosLink: z.string().nullable(),
   }),
   raffleStats: RaffleStatsSchema.optional(),
   isFrozen: z.boolean().nullable(),
   totalEntries: z.number(),
   userEntries: z.number(),
});

export const ProductItemsSchema = z.object({
   pagination: z.object({
      status: z.string().optional(),
      type: z.string().optional(),
      page: z.number(),
      limit: z.number(),
      total: z.number().nullable(),
      userEntriesOnly: z.boolean().optional(),
   }),
   productItems: z.array(ProductItemSchema).nullable(),
});

export const ProductItemsResponseSchema = z.object({
   count: z.number(),
   productItems: z.array(ProductItemSchema),
});

/**
 * export type ProductDetailsModel = {
   category: string;
   details: {
      key: string;
      value: string;
   }[]
}
 */
